import { useTranslation } from "react-i18next";
import {Button, Col, DatePicker, Form, FormInstance, Row, Typography} from 'antd';
import React from 'react';
import FormItemDropdown from '../../../../form-dropdown/FormItemDropdown';
import {DeleteOutlined, FilterOutlined} from "@ant-design/icons";
import {FilterData} from "./filter";
import {get} from 'lodash';

type FilterGroupTypes = {
  form: FormInstance,
  showFilter: boolean,
  onFinish?: any;
  filterData: FilterData
  clearFilter: () => void;
  dataOptions?: any;
  typeQuestion?: boolean
}

const FilterGroup = ({
  showFilter,
  form,
  filterData,
  dataOptions,
  onFinish,
  clearFilter,
  typeQuestion
}: FilterGroupTypes) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;

  const publishStatus = [
    {
      label: t("Bản nháp", "Bản nháp"),
      value: '0'
    },
    {
      label: t("Chờ QTCS duyệt", "Chờ QTCS duyệt"),
      value: '1'
    },
    {
      label: t("Chờ cấp bộ duyệt", "Chờ cấp bộ duyệt"),
      value: '2'
    },
    {
      label: t("QTCS không duyệt", "QTCS không duyệt"),
      value: '3'
    },
    {
      label: t("Cấp Bộ không duyệt", "Cấp Bộ không duyệt"),
      value: '4'
    },
    {
      label: t("Đã lên lịch", "Đã lên lịch"),
      value: '5'
    },
    {
      label: t("Đã xuất bản", "Đã xuất bản"),
      value: '6'
    },
    {
      label: t("Chưa xuất bản", "Chưa xuất bản"),
      value: '7'
    },
    {
      label: t("Đề xuất chỉnh sửa", "Đề xuất chỉnh sửa"),
      value: '8'
    }
  ];
  return (
    <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
      <Form form={form} name="filterForm" onFinish={onFinish}>
        <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
          <Col
            xl={{span: 4}}
            md={{span: 5}}
            sm={{span: 5}}
            xs={{span: 24}}
          >
            <Typography.Title level={5}>{t("Chủ đề", "Chủ đề")}</Typography.Title>
            <Form.Item name="topic">
              <FormItemDropdown
                modeDropdown="multiple"
                placeholder={t("Chọn chủ đề", "Chọn chủ đề")}
                options={dataOptions.dataTopic}
              />
            </Form.Item>
          </Col>
          {
            !typeQuestion ?
              <>
                <Col
                  xl={{span: 4}}
                  md={{span: 5}}
                  sm={{span: 5}}
                  xs={{span: 24}}
                >
                  <Typography.Title level={5}>{t("Quyền truy cập", "Quyền truy cập")}</Typography.Title>
                  <Form.Item name="permission">
                    <FormItemDropdown
                      modeDropdown="multiple"
                      placeholder={t("Chọn quyền truy cập", "Chọn quyền truy cập")}
                      options={dataOptions.dataPermission}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xl={{span: 4}}
                  md={{span: 5}}
                  sm={{span: 5}}
                  xs={{span: 24}}
                >
                  <Typography.Title level={5}>{t("Ngày cập nhật", "Ngày cập nhật")}</Typography.Title>
                  <Form.Item name="updatedDate">
                    <RangePicker
                      placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                      format="DD/MM/YYYY"
                      value={filterData.updatedDate}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xl={{span: 4}}
                  md={{span: 5}}
                  sm={{span: 5}}
                  xs={{span: 24}}
                >
                  <Typography.Title level={5}>{t("Tình trạng", "Tình trạng")}</Typography.Title>
                  <Form.Item name="status">
                    <FormItemDropdown
                      modeDropdown="multiple"
                      placeholder={t("Chọn tình trạng", "Chọn tình trạng")}
                      options={publishStatus}
                    />
                  </Form.Item>
                </Col>
              </>
              :
              <>
                <Col xl={{span: 4}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
                  <Typography.Title level={5}>{t("Phân cấp", "Phân cấp")}</Typography.Title>
                  <Form.Item name="level">
                    <FormItemDropdown
                      modeDropdown='multiple'
                      placeholder={t("Chọn phân cấp", "Chọn phân cấp")}
                      options={get(dataOptions, 'dataLevel')}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{span: 4}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
                  <Typography.Title level={5}>{t("Đơn vị xuất bản", "Đơn vị xuất bản")}</Typography.Title>
                  <Form.Item name="unit">
                    <FormItemDropdown modeDropdown="multiple" placeholder={t("Chọn đơn vị xuất bản", "Chọn đơn vị xuất bản")} options={get(dataOptions, 'dataUnit')}/>
                  </Form.Item>
                </Col>
                <Col xl={{span: 4}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
                  <Typography.Title level={5}>{t("Thời gian", "Thời gian")}</Typography.Title>
                  <Form.Item name="time">
                    <DatePicker.RangePicker allowEmpty={[true, true]} placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
                                            format='DD/MM/YYYY'/>
                  </Form.Item>
                </Col>
              </>
          }
          <Col
            xl={{span: 3}}
            md={{span: 9}}
            sm={{span: 9}}
            xs={{span: 24}}
            className="flex align-end"
          >
            <div className="group-btn--filter">
              <Button
                className="btn btn-primary filter-btn"
                htmlType="submit"
                onClick={() => form.submit()}
              >
                <FilterOutlined/>
                <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-outlined clear-filter-btn"
                onClick={clearFilter}
              >
                <DeleteOutlined/>
                <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FilterGroup;